/* eslint-disable import/prefer-default-export */

// IMPORTANT: The fields retuned in this query should match
// the mutation in /caseManagement/src/graphQLConnect/gQlUpdatedPreparedForm,
// or else the subscription may not work correctly.
export const onUpdatePreparedForm = /* GraphQL */ `
  subscription CustomOnUpdatePreparedForm($id: ID!) {
    onUpdatePreparedForm(id: $id) {
      ### Start fields ###
      id
      caseID
      companyID
      foreignNationalID
      relativeAdmins
      state
      preparerID
      templateID
      completedFormID
      assignedToID

      createdAt
      updatedAt

      activities {
        items {
          id
          activityType
          actorID
          actorEmployer {
            id
            slug
            firstname
            lastname
          }
          actorForeignNational {
            id
            slug
            firstname
            lastname
          }
          actorTeamMember {
            id
            slug
            firstname
            lastname
          }
        }
      }

      foreignNational {
        id
        slug
        firstname
        lastname
      }
      preparer {
        id
        slug
        firstname
        lastname
      }

      assignedToEmployer {
        firstname
        lastname
        id
      }

      assignedToNational {
        firstname
        lastname
        id
      }

      assignedToTeamMember {
        firstname
        lastname
        id
      }

      requiresAttorneyApproval
      attorneyApprover {
        firstname
        lastname
        slug
        id
      }
      attorneyApprovalDate
      attorneyApproverID

      requiresSponsorApproval
      sponsorApprovalDate
      sponsorApproverEmployer {
        firstname
        lastname
        slug
        id
      }
      sponsorApproverNational {
        firstname
        lastname
        slug
        id
      }
      sponsorApproverID

      requiresNationalApproval
      nationalApprover {
        firstname
        lastname
        slug
        id
      }
      nationalApprovalDate
      nationalApproverID

      finalCaseManagerApprover {
        firstname
        lastname
        slug
        id
      }
      finalCaseManagerApprovalDate
      finalCaseManagerApproverID

      employersCanView
      nationalsCanView

      completedForm {
        id
        expirationDate
        fileName
        fileType
        contentType
        isFlattened
        processRequestID
        companyID
        sourceID
        ownerNationalID
        uploadDate
        uploaderID
        original {
          bucket
          key
          level
          region
          identityId
        }
      }
      rejectedByID
      rejectedDate
      rejectedByTeamMember {
        id
        firstname
        lastname
        slug
      }
      rejectedByNational {
        id
        firstname
        lastname
        slug
      }
      rejectedByEmployer {
        id
        firstname
        lastname
        slug
      }
      completedFormHistory {
        items {
          original {
            bucket
            identityId
            key
            level
            region
          }
          fileName
          fileType
          id
          uploadDate
        }
      }
      comments {
        items {
          id
        }
      }
      ### End fields ###
    }
  }
`;

export const updatePreparedForm = /* GraphQL */ `
  mutation CustomUpdatePreparedForm(
    $input: UpdatePreparedFormInput!
    $condition: ModelPreparedFormConditionInput
  ) {
    updatePreparedForm(input: $input, condition: $condition) {
      caseID
      companyID
      completedFormID
      createdAt
      id
      foreignNationalID
      preparerID
      relativeAdmins
      state
      templateID
      updatedAt
      assignedToID
      activities {
        items {
          id
          activityType
          actorID
          actorEmployer {
            id
            slug
            firstname
            lastname
          }
          actorForeignNational {
            id
            slug
            firstname
            lastname
          }
          actorTeamMember {
            id
            slug
            firstname
            lastname
          }
          targetEmployer {
            id
            slug
            firstname
            lastname
          }
          targetForeignNational {
            id
            slug
            firstname
            lastname
          }
          targetTeamMember {
            id
            slug
            firstname
            lastname
          }
          ownerCase {
            sourceID
            state
            createdAt
            updatedAt
          }
        }
      }
      case {
        caseManagerID
      }
      comments {
        items {
          id
        }
      }
      preparer {
        id
        firstname
        lastname
        slug
        avatar {
          original {
            bucket
            key
            level
            region
            identityId
          }
          squareThumbnails {
            image {
              bucket
              key
              level
              region
              identityId
            }
            size
          }
        }
      }
      completedForm {
        id
        expirationDate
        fileName
        fileType
        contentType
        isFlattened
        original {
          bucket
          region
          key
          level
          identityId
        }
        processRequestID
        companyID
        sourceID
        ownerNationalID
        uploadDate
        uploaderID
        uploaderEmployer {
          id
          firstname
          lastname
          slug
          avatar {
            original {
              bucket
              key
              level
              region
              identityId
            }
            squareThumbnails {
              image {
                bucket
                key
                level
                region
                identityId
              }
              size
            }
          }
        }
        uploaderForeignNational {
          id
          firstname
          lastname
          slug
          avatar {
            original {
              bucket
              key
              level
              region
              identityId
            }
            squareThumbnails {
              image {
                bucket
                key
                level
                region
                identityId
              }
              size
            }
            version
          }
        }
        uploaderTeamMember {
          id
          firstname
          lastname
          slug
          avatar {
            original {
              bucket
              key
              level
              region
              identityId
            }
            squareThumbnails {
              image {
                bucket
                key
                level
                region
                identityId
              }
              size
            }
            version
          }
        }
        createdAt
        updatedAt
      }

      assignedToEmployer {
        firstname
        lastname
        id
      }

      assignedToNational {
        firstname
        lastname
        id
      }

      assignedToTeamMember {
        firstname
        lastname
        id
      }

      requiresAttorneyApproval
      attorneyApprover {
        firstname
        lastname
        slug
        id
      }
      attorneyApprovalDate
      attorneyApproverID

      requiresSponsorApproval
      sponsorApprovalDate
      sponsorApproverEmployer {
        firstname
        lastname
        slug
        id
      }
      sponsorApproverNational {
        firstname
        lastname
        slug
        id
      }
      sponsorApproverID

      requiresNationalApproval
      nationalApprover {
        firstname
        lastname
        slug
        id
      }
      nationalApprovalDate
      nationalApproverID

      finalCaseManagerApprover {
        firstname
        lastname
        slug
        id
      }
      finalCaseManagerApprovalDate
      finalCaseManagerApproverID

      employersCanView
      nationalsCanView

      rejectedByID
      rejectedDate
      rejectedByTeamMember {
        id
        firstname
        lastname
        slug
      }
      rejectedByNational {
        id
        firstname
        lastname
        slug
      }
      rejectedByEmployer {
        id
        firstname
        lastname
        slug
      }
    }
  }
`;

export const listFormComments = /* GraphQL */ `
query ListFormComments($id: ID!) {
    getPreparedForm(id: $id) {
      comments {
        items {
          authorID
          authorEmployer {
            id
            lastname
            firstname
            avatar {
              original {
                bucket
                identityId
                key
                level
                region
              }
              squareThumbnails {
                image {
                  region
                  level
                  key
                  identityId
                  bucket
                }
                size
              }
            }
          }
          authorForeignNational {
            id
            lastname
            firstname
            avatar {
              original {
                bucket
                identityId
                key
                level
                region
              }
              squareThumbnails {
                image {
                  region
                  level
                  key
                  identityId
                  bucket
                }
                size
              }
            }
          }
          authorTeamMember {
            id
            lastname
            firstname
            avatar {
              original {
                bucket
                identityId
                key
                level
                region
              }
              squareThumbnails {
                image {
                  region
                  level
                  key
                  identityId
                  bucket
                }
                size
              }
            }
          }
          id
          createdAt
          note
        }
      }
    }
  }
`;
